module.exports = __webpack_public_path__ + "assets/img/information-hint.092f27a5.png";